import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
}

export const img = (variant, id) => `${API}/media/${variant}/${id}`;
export const brl = (cents) => ((cents ?? 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const fmtDate = (s) => {
  if (!s) return "";
  const [y, m, d] = s.split("-");
  return d && m && y ? `${d}/${m}/${y}` : s;
};

export const CATEGORIES = [
  { id: "social", label: "Social", desc: "Casamentos, formaturas, festas e celebrações.", img: "/img/social.jpg" },
  { id: "esportivo", label: "Esportivo", desc: "Corridas, torneios, campeonatos e provas.", img: "/img/beach.jpg" },
  { id: "empresarial", label: "Empresarial", desc: "Congressos, convenções, feiras e lançamentos.", img: "/img/corp.jpg" },
  { id: "particular", label: "Particular", desc: "Aniversários, ensaios e encontros privados.", img: "/img/party.jpg" },
];
export const catLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label || id;

export const STATUS = {
  pending: { label: "Aguardando pagamento", tone: "bg-amber-400/15 text-amber-300 border-amber-400/30" },
  awaiting_confirmation: { label: "Comprovante em análise", tone: "bg-violet-400/15 text-violet-200 border-violet-400/30" },
  approved: { label: "Pago", tone: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30" },
  rejected: { label: "Recusado", tone: "bg-red-400/15 text-red-300 border-red-400/30" },
};
